export const ADD_LIST_ITEM_REQUEST = 'ADD_LIST_ITEM_REQUEST';
export const ADD_LIST_ITEM_SUCCESS = 'ADD_LIST_ITEM_SUCCESS';
export const ADD_LIST_ITEM_ERROR = 'ADD_LIST_ITEM_ERROR';

export const REMOVE_LIST_ITEM_REQUEST = 'REMOVE_LIST_ITEM_REQUEST';
export const REMOVE_LIST_ITEM_SUCCESS = 'REMOVE_LIST_ITEM_SUCCESS';
export const REMOVE_LIST_ITEM_ERROR = 'REMOVE_LIST_ITEM_ERROR';

export const RESTORE_LIST_ITEM_REQUEST = 'RESTORE_LIST_ITEM_REQUEST';
export const RESTORE_LIST_ITEM_SUCCESS = 'RESTORE_LIST_ITEM_SUCCESS';
export const RESTORE_LIST_ITEM_ERROR = 'RESTORE_LIST_ITEM_ERROR';

export const REMOVE_LIST_REQUEST = 'REMOVE_LIST_REQUEST';
export const REMOVE_LIST_SUCCESS = 'REMOVE_LIST_SUCCESS';
export const REMOVE_LIST_ERROR = 'REMOVE_LIST_ERROR';

export const RESTORE_LIST_REQUEST = 'RESTORE_LIST_REQUEST';
export const RESTORE_LIST_SUCCESS = 'RESTORE_LIST_SUCCESS';
export const RESTORE_LIST_ERROR = 'RESTORE_LIST_ERROR';

export const CREATE_LIST_REQUEST = 'CREATE_LIST_REQUEST';
export const CREATE_LIST_SUCCESS = 'CREATE_LIST_SUCCESS';
export const CREATE_LIST_ERROR = 'CREATE_LIST_ERROR';

export const EDIT_LIST_REQUEST = 'EDIT_LIST_REQUEST';
export const EDIT_LIST_SUCCESS = 'EDIT_LIST_SUCCESS';
export const EDIT_LIST_ERROR = 'EDIT_LIST_ERROR';

export const SORT_LIST = 'SORT_LIST';
export const SELECT_LIST = 'SELECT_LIST';

export const OPEN_LISTS = 'OPEN_LISTS';
export const CLOSE_LISTS = 'CLOSE_LISTS';

export const ORDER_LISTS_REQUEST = 'ORDER_LISTS_REQUEST';
export const ORDER_LIST_ITEMS_REQUEST = 'ORDER_LIST_ITEMS_REQUEST';

export const ADD_ITEM_TO_MY_PRODUCTS_REQUEST =
  'ADD_ITEM_TO_MY_PRODUCTS_REQUEST';

export const IMPORT_LIST_TO_MY_PRODUCTS = 'IMPORT_LIST_TO_MY_PRODUCTS';
export const IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS =
  'IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS';

export const addListItemRequest = (product, isDesktop) => ({
  type: ADD_LIST_ITEM_REQUEST,
  product,
  isDesktop,
});

export const addListItemSuccess = (id, listId, product) => ({
  type: ADD_LIST_ITEM_SUCCESS,
  product,
  id,
  listId,
});

export const addListItemError = error => ({
  type: ADD_LIST_ITEM_ERROR,
  error,
});

export const removeListItemRequest = (id, listId) => ({
  type: REMOVE_LIST_ITEM_REQUEST,
  id,
  listId,
});

export const removeListItemSuccess = (restoreToken, id, listId) => ({
  type: REMOVE_LIST_ITEM_SUCCESS,
  restoreToken,
  id,
  listId,
});

export const removeListItemError = error => ({
  type: REMOVE_LIST_ITEM_ERROR,
  error,
});

export const restoreListItemRequest = (id, restoreToken) => ({
  type: RESTORE_LIST_ITEM_REQUEST,
  restoreToken,
  id,
});

export const restoreListItemSuccess = (id, restoreToken) => ({
  type: RESTORE_LIST_ITEM_SUCCESS,
  id,
  restoreToken,
});

export const restoreListItemError = error => ({
  type: RESTORE_LIST_ITEM_ERROR,
  error,
});

export const removeListRequest = id => ({
  type: REMOVE_LIST_REQUEST,
  id,
});

export const removeListSuccess = (restoreToken, id) => ({
  type: REMOVE_LIST_SUCCESS,
  restoreToken,
  id,
});

export const removeListError = error => ({
  type: REMOVE_LIST_ERROR,
  error,
});

export const restoreListRequest = (id, restoreToken) => ({
  type: RESTORE_LIST_REQUEST,
  restoreToken,
  id,
});

export const restoreListSuccess = (id, restoreToken) => ({
  type: RESTORE_LIST_SUCCESS,
  id,
  restoreToken,
});

export const restoreListError = error => ({
  type: RESTORE_LIST_ERROR,
  error,
});

export const createListRequest = listName => ({
  type: CREATE_LIST_REQUEST,
  listName,
});

export const createListSuccess = list => ({
  type: CREATE_LIST_SUCCESS,
  list,
});

export const createListError = error => ({
  type: CREATE_LIST_ERROR,
  error,
});

export const editListRequest = (id, name, visibility) => ({
  type: EDIT_LIST_REQUEST,
  id,
  name,
  visibility,
});

export const editListSuccess = list => ({
  type: EDIT_LIST_SUCCESS,
  list,
});

export const editListError = error => ({
  type: EDIT_LIST_ERROR,
  error,
});

export const sortList = sort => ({
  type: SORT_LIST,
  sort,
});

export const selectList = id => ({
  type: SELECT_LIST,
  id,
});

export const openLists = () => ({
  type: OPEN_LISTS,
  open: true,
});

export const closeLists = () => ({
  type: CLOSE_LISTS,
  open: false,
});

export const orderListsRequest = listIds => ({
  type: ORDER_LISTS_REQUEST,
  listIds,
});

export const orderListItemsRequest = (listId, listItemIds) => ({
  type: ORDER_LIST_ITEMS_REQUEST,
  listId,
  listItemIds,
});

export const addItemToMyProductsRequest = (product, isDesktop) => ({
  type: ADD_ITEM_TO_MY_PRODUCTS_REQUEST,
  product,
  isDesktop,
});

export const importListToMyProducts = listId => ({
  type: IMPORT_LIST_TO_MY_PRODUCTS,
  listId,
});

export const importListToMyProductsSuccess = () => ({
  type: IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS,
});
